<template>
  <div class="privacy-container">
    <div class="privacy-head">
      <div class="head-inner">
        <div>
          <h1 v-if="lang === 'mn'">Нууцлалын бодлого</h1>
          <h1 v-else>Privacy Policy</h1>
          <p class="subtitle" v-if="lang === 'mn'">
            ИМЖ.мн вэбсайт болон IMJ Math гар утасны апп
          </p>
          <p class="subtitle" v-else>
            imj.mn website and the IMJ Math mobile app
          </p>
        </div>
        <div class="lang-toggle">
          <button
            type="button"
            :class="{ active: lang === 'mn' }"
            @click="setLang('mn')"
          >
            MN
          </button>
          <button
            type="button"
            :class="{ active: lang === 'en' }"
            @click="setLang('en')"
          >
            EN
          </button>
        </div>
      </div>
    </div>

    <div class="privacy-card">
      <p class="updated" v-if="lang === 'mn'">
        Хамгийн сүүлд шинэчилсэн: 2026 оны 9 дүгээр сарын 20
      </p>
      <p class="updated" v-else>Last updated: September 20, 2026</p>

      <!-- MONGOLIAN -->
      <div v-if="lang === 'mn'">
        <section>
          <p>
            “Искүүл” ХХК /цаашид “Байгууллага”, "бид", "манай" гэх/ нь Монгол
            улсын ерөнхий боловсролын сургуулийн сурагчдад зориулсан
            математикийн дасгал, тестийн платформыг
            <a href="https://imj.mn">www.imj.mn</a> цахим хуудас болон "IMJ
            Math" гар утасны аппликейшнээр дамжуулан үйлчилгээгээ үзүүлдэг.
            Энэхүү Нууцлалын бодлого нь Байгууллага хэрэглэгчдээсээ ямар
            мэдээлэл цуглуулж, хэрхэн ашиглаж, хадгалж, хамгаалдгийг
            тайлбарлана. Манай үйлчилгээг ашигласнаар та энэхүү бодлого болон
            Үйлчилгээний нөхцөлийг зөвшөөрч байгаа болно.
          </p>
        </section>

        <section>
          <h2>1. Бидний цуглуулдаг мэдээлэл</h2>
          <p><strong>Бүртгэлийн үед (эцэг эх/асран хамгаалагчаас):</strong></p>
          <ul>
            <li>Эцэг эхийн овог, нэр, имэйл хаяг</li>
            <li>Утасны дугаар (нэвтрэх нэр болон SMS баталгаажуулалтад ашиглана)</li>
            <li>Хүүхдийн нэр, төрсөн огноо, анги/бүлэг, сургуулийн нэр, байршил</li>
          </ul>
          <p><strong>Үйлчилгээг ашиглах явцад:</strong></p>
          <ul>
            <li>Хариулсан асуулт, авсан оноо, дуусгасан түвшин, ахиц дэвшлийн түүх</li>
            <li>
              Профайлын аватар (дүрс) тохиргоо — өнгө, нүд, амны загвар зэрэг
              хувийн бус харагдах байдлын мэдээлэл
            </li>
            <li>
              Багц/эрхийн худалдан авалтын түүх, төлбөрийн статус (карт эсвэл
              дансны дэлгэрэнгүй мэдээллийг бид хадгалдаггүй — үүнийг QPay
              төлбөрийн үйлчилгээ үзүүлэгч боловсруулна)
            </li>
            <li>
              Төхөөрөмжийн ерөнхий мэдээлэл, нэвтрэлтийн token (JWT), IP хаяг
              зэрэг үйлчилгээг найдвартай, аюулгүй ажиллуулахад шаардлагатай
              техникийн мэдээлэл
            </li>
          </ul>
        </section>

        <section>
          <h2>2. Мэдээллийг ашиглах зорилго</h2>
          <ul>
            <li>Хэрэглэгчийн бүртгэл үүсгэх, нэвтрэлтийг баталгаажуулах</li>
            <li>Сурагчийн сурлагын ахиц дэвшлийг хадгалж, харуулах</li>
            <li>Багц/эрхийн худалдан авалтыг боловсруулах</li>
            <li>Нууц үг сэргээх зааврыг имэйлээр илгээх, OTP кодыг SMS-ээр илгээх</li>
            <li>Үйлчилгээний алдааг олж засварлах, чанарыг сайжруулах</li>
            <li>Хууль тогтоомжийн шаардлагыг хангах</li>
          </ul>
        </section>

        <section>
          <h2>3. Хүүхдийн мэдээллийн нууцлал</h2>
          <p>
            ИМЖ.мн-ийг үндсэндээ сургуулийн насны хүүхдүүд ашигладаг тул бид
            хүүхдийн мэдээллийн нууцлалд онцгой анхаарал хандуулдаг:
          </p>
          <ul>
            <li>
              Бүртгэлийг зөвхөн эцэг эх, асран хамгаалагч үүсгэж,
              баталгаажуулна. Хүүхэд өөрөө шууд имэйл, утасны дугаар, төлбөрийн
              мэдээлэл бидэнд өгдөггүй.
            </li>
            <li>
              Бид хүүхдийн мэдээллийг зар сурталчилгааны зорилгоор ашигладаггүй,
              гуравдагч этгээдэд худалддаггүй.
            </li>
            <li>
              Эцэг эх, асран хамгаалагч хүссэн үедээ хүүхдийнхээ мэдээлэлтэй
              танилцах, засварлуулах, бүрмөсөн устгуулах хүсэлтийг
              <a href="mailto:info@imj.mn">info@imj.mn</a> хаягаар илгээх эрхтэй.
            </li>
          </ul>
        </section>

        <section>
          <h2>4. Мэдээлэл гуравдагч этгээдтэй хуваалцах</h2>
          <p>
            Бид үйлчилгээгээ хэвийн ажиллуулахад шаардлагатай дараах үйлчилгээ
            үзүүлэгчидтэй зөвхөн шаардлагатай хэмжээний мэдээллийг хуваалцдаг:
          </p>
          <ul>
            <li><strong>QPay (qpay.mn)</strong> — төлбөр тооцоо хийхэд</li>
            <li>
              <strong>Amazon Web Services (AWS SES)</strong> — имэйл мэдэгдэл,
              нууц үг сэргээх зааврыг илгээхэд
            </li>
            <li>
              <strong>Skytel</strong> — бүртгэл баталгаажуулах SMS/OTP код
              илгээхэд
            </li>
          </ul>
          <p>
            Бид хэрэглэгчийн хувийн мэдээллийг арилжааны зорилгоор гуравдагч
            этгээдэд худалддаггүй бөгөөд хууль тогтоомжид заасан үндэслэлээс
            бусад тохиолдолд таны зөвшөөрөлгүйгээр өөр зорилгоор ашиглахгүй.
          </p>
        </section>

        <section>
          <h2>5. Мэдээллийн аюулгүй байдал</h2>
          <ul>
            <li>
              Нэвтрэх нууц үгийг эргэлт буцалтгүй (irreversible) хэш функцээр
              шифрлэн хадгална
            </li>
            <li>Нэвтрэлт, эрхийг JWT токен ашиглан баталгаажуулна</li>
            <li>Өгөгдөл дамжуулалт HTTPS протоколоор шифрлэгдэнэ</li>
          </ul>
        </section>

        <section>
          <h2>6. Мэдээлэл хадгалах хугацаа</h2>
          <p>
            Бүртгэл идэвхтэй байх хугацаанд холбогдох мэдээллийг хадгална.
            Хэрэглэгч бүртгэлээ устгуулахыг хүсвэл
            <a href="mailto:info@imj.mn">info@imj.mn</a> хаягаар хандана уу.
            Хуулийн дагуу хадгалах шаардлагатай мэдээллээс бусад мэдээллийг
            боломжит хугацаанд устгана.
          </p>
        </section>

        <section>
          <h2>7. Таны эрх</h2>
          <ul>
            <li>Өөрийн болон хүүхдийнхээ мэдээлэлтэй танилцах</li>
            <li>Буруу, хуучирсан мэдээллийг засварлуулах</li>
            <li>Мэдээллээ устгуулах хүсэлт гаргах</li>
            <li>Мэдэгдэл, имэйл авахаас татгалзах</li>
          </ul>
        </section>

        <section>
          <h2>8. Күүки болон нэвтрэлтийн технологи</h2>
          <p>
            Бид гуравдагч талын зар сурталчилгааны күүки ашигладаггүй. Зөвхөн
            хэрэглэгчийн нэвтрэлтийг хадгалж, аюулгүй байдлыг хангахад
            шаардлагатай нэвтрэлтийн токеныг ашигладаг.
          </p>
        </section>

        <section>
          <h2>9. Бодлогын өөрчлөлт</h2>
          <p>
            Бид энэхүү Нууцлалын бодлогыг цаг тухайд нь шинэчилж болно. Чухал
            өөрчлөлт орсон тохиолдолд энэ хуудсан дээрх "Хамгийн сүүлд
            шинэчилсэн" огноог шинэчилнэ.
          </p>
        </section>

        <section>
          <h2>10. Холбоо барих</h2>
          <div class="contact-box">
            <p><strong>“Искүүл” ХХК</strong></p>
            <p>Имэйл: <a href="mailto:info@imj.mn">info@imj.mn</a></p>
            <p>Вэбсайт: <a href="https://imj.mn">www.imj.mn</a></p>
          </div>
        </section>
      </div>

      <!-- ENGLISH -->
      <div v-else>
        <section>
          <p>
            “Iskuul” LLC (referred to as "the Company", "we", "our") provides a
            math practice and testing platform for primary and secondary
            school pupils in Mongolia, delivered through the
            <a href="https://imj.mn">www.imj.mn</a> website and the "IMJ Math"
            mobile app. This Privacy Policy explains what information the
            Company collects from users, how it is used, stored, and
            protected. By using our service, you agree to this Privacy Policy
            and our Terms of Service.
          </p>
        </section>

        <section>
          <h2>1. Information we collect</h2>
          <p><strong>At registration (provided by a parent/guardian):</strong></p>
          <ul>
            <li>Parent/guardian's name and email address</li>
            <li>Phone number (used as the login username and for SMS verification)</li>
            <li>Child's name, date of birth, grade/class, school name, and location</li>
          </ul>
          <p><strong>While using the service:</strong></p>
          <ul>
            <li>Answers submitted, scores, completed levels, and learning progress history</li>
            <li>
              Profile avatar settings — color, eyes, mouth style, and similar
              non-personal appearance choices
            </li>
            <li>
              Purchase history for content packages/access and payment status
              (we do not store card or bank details — these are processed by our
              payment provider, QPay)
            </li>
            <li>
              General device information, authentication tokens (JWT), IP
              address, and similar technical data needed to operate the service
              securely and reliably
            </li>
          </ul>
        </section>

        <section>
          <h2>2. How we use information</h2>
          <ul>
            <li>To create accounts and verify logins</li>
            <li>To save and display a pupil's learning progress</li>
            <li>To process purchases of content packages/access</li>
            <li>To send password-reset instructions by email and OTP codes by SMS</li>
            <li>To find and fix issues and improve the service</li>
            <li>To comply with legal obligations</li>
          </ul>
        </section>

        <section>
          <h2>3. Children's privacy</h2>
          <p>
            Because IMJ.mn is primarily used by school-age children, we take
            particular care with children's data:
          </p>
          <ul>
            <li>
              Accounts are created and verified only by a parent or guardian.
              Children do not directly provide us with an email address, phone
              number, or payment information.
            </li>
            <li>
              We do not use children's information for advertising purposes and
              do not sell it to third parties.
            </li>
            <li>
              A parent or guardian may request to review, correct, or
              permanently delete their child's information at any time by
              emailing <a href="mailto:info@imj.mn">info@imj.mn</a>.
            </li>
          </ul>
        </section>

        <section>
          <h2>4. Sharing information with third parties</h2>
          <p>
            We share only the minimum information necessary with the following
            service providers required to operate the platform:
          </p>
          <ul>
            <li><strong>QPay (qpay.mn)</strong> — to process payments</li>
            <li>
              <strong>Amazon Web Services (AWS SES)</strong> — to send email
              notifications and password-reset instructions
            </li>
            <li><strong>Skytel</strong> — to send SMS/OTP verification codes</li>
          </ul>
          <p>
            We do not sell personal information to third parties for commercial
            purposes and do not use it for other purposes without your consent,
            except where required by law.
          </p>
        </section>

        <section>
          <h2>5. Data security</h2>
          <ul>
            <li>Passwords are stored using an irreversible cryptographic hash</li>
            <li>Login sessions are secured using JWT access tokens</li>
            <li>Data in transit is encrypted using HTTPS</li>
          </ul>
        </section>

        <section>
          <h2>6. Data retention</h2>
          <p>
            We retain account information for as long as the account remains
            active. If you would like your account deleted, please contact
            <a href="mailto:info@imj.mn">info@imj.mn</a>. Information will be
            deleted within a reasonable time, except where retention is required
            by law.
          </p>
        </section>

        <section>
          <h2>7. Your rights</h2>
          <ul>
            <li>Access your own or your child's information</li>
            <li>Request correction of inaccurate or outdated information</li>
            <li>Request deletion of your information</li>
            <li>Opt out of non-essential notifications or emails</li>
          </ul>
        </section>

        <section>
          <h2>8. Cookies and login technology</h2>
          <p>
            We do not use third-party advertising cookies. We only use
            login/session tokens needed to keep you signed in and to keep the
            service secure.
          </p>
        </section>

        <section>
          <h2>9. Changes to this policy</h2>
          <p>
            We may update this Privacy Policy from time to time. If we make
            material changes, we will update the "Last updated" date at the top
            of this page.
          </p>
        </section>

        <section>
          <h2>10. Contact us</h2>
          <div class="contact-box">
            <p><strong>“Iskuul” LLC</strong></p>
            <p>Email: <a href="mailto:info@imj.mn">info@imj.mn</a></p>
            <p>Website: <a href="https://imj.mn">www.imj.mn</a></p>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
const LANG_KEY = "imj_privacy_lang";

export default {
  data() {
    return {
      lang: "mn",
    };
  },
  created() {
    try {
      const saved = localStorage.getItem(LANG_KEY);
      if (saved === "en" || saved === "mn") {
        this.lang = saved;
      }
    } catch (e) {
      // localStorage байхгүй үед монгол хувилбараар үзүүлнэ
    }
  },
  methods: {
    setLang(lang) {
      this.lang = lang;
      try {
        localStorage.setItem(LANG_KEY, lang);
      } catch (e) {
        // хадгалах боломжгүй бол алгасна
      }
    },
  },
};
</script>

<style scoped>
.privacy-container {
  font-family: "Roboto", sans-serif;
  color: #11181c;
  line-height: 1.65;
  padding-bottom: 60px;
  background: #f8fafc;
}
.privacy-head {
  background: linear-gradient(135deg, #22b353, #1a8f42);
  color: #ffffff;
  padding: 40px 20px 44px;
}
.head-inner {
  max-width: 760px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  flex-wrap: wrap;
}
h1 {
  margin: 0 0 4px;
  font-size: 1.75em;
}
.subtitle {
  margin: 0;
  opacity: 0.92;
  font-size: 0.94em;
}
.lang-toggle {
  display: inline-flex;
  background: rgba(255, 255, 255, 0.16);
  border-radius: 999px;
  padding: 3px;
}
.lang-toggle button {
  border: none;
  background: transparent;
  color: #ffffff;
  padding: 6px 14px;
  border-radius: 999px;
  font-size: 0.82em;
  font-weight: 600;
  cursor: pointer;
}
.lang-toggle button.active {
  background: #ffffff;
  color: #22b353;
}
.privacy-card {
  max-width: 760px;
  margin: -20px auto 0;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 32px 28px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.06);
}
.updated {
  color: #64748b;
  font-size: 0.82em;
  margin: 0 0 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e2e8f0;
}
section {
  margin-bottom: 28px;
}
section:last-child {
  margin-bottom: 0;
}
h2 {
  font-size: 1.12em;
  margin: 0 0 10px;
  color: #22b353;
}
p {
  margin: 0 0 12px;
  color: #475569;
}
ul {
  margin: 0 0 12px;
  padding-left: 20px;
  color: #475569;
}
li {
  margin-bottom: 6px;
}
strong {
  color: #11181c;
}
a {
  color: #22b353;
}
.contact-box {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 16px 18px;
}
.contact-box p {
  margin: 0 0 4px;
}
.contact-box p:last-child {
  margin-bottom: 0;
}
@media screen and (max-width: 600px) {
  .privacy-card {
    margin: -20px 12px 0;
    padding: 24px 18px;
  }
}
</style>
